import { CLIENT_TYPES_ID, ClientTypes } from '~/constants/clientTypes.ts';
import { TGettingStarted } from './types';
import api from '~/libs/api';

export const getingStartedInitialValues = (formData?: TGettingStarted): TGettingStarted => ({
  contragentType: formData?.contragentType || null,
  tariffPackage: formData?.tariffPackage || null,
  region: formData?.region || null,
  tobo: formData?.tobo || null,
  currency: formData?.currency || [{ value: '980', label: 'Гривня' }],
  isUSTaxResident: formData?.isUSTaxResident,
  isForeignFinancialUnderFATCA: formData?.isForeignFinancialUnderFATCA,
  isOtherTaxResident: formData?.isOtherTaxResident,
  proxyAccountManagers: formData?.proxyAccountManagers,
  hasForeignShare: formData?.hasForeignShare,
  applicationId: formData?.applicationId || null,
  identificationNumber: formData?.identificationNumber || '',
  isInBankBlackList: formData?.isInBankBlackList ?? null,
  isInTerList: formData?.isInTerList ?? null,
  type: formData?.type,
  contragentId: null,
  identificationType: formData?.identificationType || null,
  verification: formData?.verification ?? null,
  applicationNumber: formData?.applicationNumber,
});

export const getContragentType = (identificationNumber: string) => {
  if (!/^\d+$/.test(identificationNumber)) {
    return null;
  }

  switch (identificationNumber.length) {
    case 8:
      return CLIENT_TYPES_ID[ClientTypes.LEGAL_RESIDENT];

    case 9:
      return CLIENT_TYPES_ID[ClientTypes.LEGAL_NON_RESIDENT];

    case 10:
      return CLIENT_TYPES_ID[ClientTypes.SOLE_TRADER];

    default:
      return null;
  }
};

export const fetchApplicationStatus = async (identificationNumber: string) => {
  const { data } = await api.get(`identification/application/status?code=${identificationNumber}`);
  return data;
};

export const fetchB2CheckResult = async (identificationNumber: string) => {
  const { data: b2CheckResult } = await api.post(`/identification/b2-integration/full-check`, {
    identificationNumber,
  });
  return b2CheckResult;
};
